import Kalista1 from "./kalista (1).webp";
import Kalista2 from "./kalista (2).webp";
import Kalista3 from "./kalista (3).webp";

const kalista = [Kalista1, Kalista2, Kalista3];

export default kalista;
